var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.289)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(0.289)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.131 7.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-221.027,168.234a2.013,2.013,0,0,1-1.984,2.017h-15.87a2.013,2.013,0,0,1-1.984-2.017V152.365a1.957,1.957,0,0,1,1.984-1.951h9.256v-1.322h-9.256a3.283,3.283,0,0,0-3.307,3.274v15.868a3.339,3.339,0,0,0,3.307,3.339h15.869a3.34,3.34,0,0,0,3.307-3.339v-9.224h-1.323v9.224Z",
    transform: "translate(242.188 -147.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-218.844,149.308a3.307,3.307,0,0,0-4.569,0l-10.839,10.838a.8.8,0,0,0-.212.373l-1.14,4.569a.806.806,0,0,0,.212.767.8.8,0,0,0,.569.237.782.782,0,0,0,.2-.025l4.571-1.142a.8.8,0,0,0,.373-.212l10.839-10.839a3.21,3.21,0,0,0,.946-2.284A3.2,3.2,0,0,0-218.844,149.308Zm-11.821,14.107-3.047.76.762-3.046,8.966-8.966,2.286,2.286Zm10.679-10.681-.571.571-2.286-2.286.571-.571a1.658,1.658,0,0,1,2.286,0,1.611,1.611,0,0,1,.473,1.144A1.61,1.61,0,0,1-219.986,152.734Z",
    transform: "translate(241.532 -148.392)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1be88a049bb286921a697866addfb9d0.svg";
export { ForwardRef as ReactComponent };